import { BioCalendarRow, BioTestResultByWeek } from "../types"
import { StyledPracticeCell } from "../../../../components/Table.styled"
import CorpCalendarTestResult from "../../../../components/CorpCalendarTestResult"
import { WaterlineCalendarRow } from "../../waterline-management/types"

const BiologicalCalendarResultsCell = ({ practice }: { practice: BioCalendarRow | WaterlineCalendarRow }) => {
  if (!('testResultsByWeek' in practice)) return ( <StyledPracticeCell/>)

  const testResults = Object.keys(practice.testResultsByWeek)

  return (
    <StyledPracticeCell>
      <div className="flex">
        {
          testResults.map((week: string, index: number) => {
            const result = practice.testResultsByWeek[week] as unknown as BioTestResultByWeek
            const title = `${result.message} ${result?.dateRange ?? ''}`.trim()
            return (
              <CorpCalendarTestResult
                key={`${practice.practiceName}-${practice.customerNumber}-tooltip-${index}`}
                title={title}
                complianceInterval='quarter'
                status={result.status}
              />
            )
          })
        }
      </div>
    </StyledPracticeCell>
  )
}

export default BiologicalCalendarResultsCell